export default {
	// متجر موحّد لكل بيانات الزبائن - يُدمَج فيه (upsert) رد كل من: Customers.vue
	// (entitiesWithTypeId)، بحث VisitDialog حسب النوع/المنطقة (entitiesWithTypeId/all)،
	// والجلب الشامل عند الإقلاع (Regions/Customers، بعد تسطيحه). انظر service-worker.js
	// لمنطق الدمج والتصفية حسب معاملات كل طلب
	entities: {
		name: 'entities',
		keyPath: 'id',
	},
	entityTypes: {
		name: 'entity-types',
		keyPath: 'id',
	},
	entitiesCountsByType: {
		name: 'entities-counts-by-type',
		keyPath: 'typeId',
	},
	materials: {
		name: 'materials',
		keyPath: 'id',
	},
	materialsSpecialty: {
		name: 'materials-specialty',
		keyPath: 'id',
	},
	specialties: {
		name: 'specialties',
		keyPath: 'id',
	},
	materialForms: {
		name: 'material-forms',
		keyPath: 'id',
	},
	priceTypes: {
		name: 'price-types',
		keyPath: 'id',
	},
	regions: {
		name: 'regions',
		keyPath: 'id',
	},
	workloads: {
		name: 'workloads',
		keyPath: 'id',
	},
	visits: {
		name: 'visits',
		keyPath: 'id',
	},
	materialsTransactions: {
		name: 'materials-transactions',
		keyPath: 'materialId',
	},
};
